
import React from "react"
import {Box, Pagination, Table, Tabs, Header, TextFilter} from "@amzn/awsui-components-react-v3"
import { AWS_RESOURCE_TYPE, getResourceName, resourceColumnDefinition, SUPPORTED_AWS_RESOURCE_TYPES } from "./ResourceTypeConstants"
import {useCollection} from "@amzn/awsui-collection-hooks";
import { TableWithNoData } from "src/components/commonComponents/table/tableWithNoData";
import { NO_ITEMS_FOUND, NO_MATCHES_FOUND } from "src/constants/CommonConstants";

export const AWSResourceTabs = ({data, pipelineName}) => {

    return (
      <> { data && pipelineName ? <Tabs tabs={getTabs(data, pipelineName)}></Tabs> : null } </>
    )
}

const getFilterCounterText = (count: number | undefined) => {
    if (count === undefined) {
        return undefined;
    }
    return `${count} ${count === 1 ? "match" : "matches"}`;
}

export const  getTabs = (data, pipelineName) => {
    let tabs : any = [];

    SUPPORTED_AWS_RESOURCE_TYPES.map( resourceType => {
        tabs.push({
            label: getResourceName(resourceType),
            id: resourceType,
            content: getResourceTabs(resourceType, reviewData(data[resourceType], pipelineName))
        })
    })
    return tabs;
}

const reviewData = (datas, pipelineName) => {
    return datas && datas.filter( item => item.Required === true && (!item.PipelineName || item.PipelineName === pipelineName)) || []
}

const getResourceTabs = (resourceType, data) => {

  switch(resourceType) {
    case AWS_RESOURCE_TYPE.DYNAMO_DB.type:
      return <DynamoReviewTable data={data} />
    case AWS_RESOURCE_TYPE.KMS.type:
      return <KMSReviewTable data={data} />
    case AWS_RESOURCE_TYPE.S3.type:
        return <S3ReviewTable data={data} />
    default:
      return <AWSReviewTable data={data} resourceType={resourceType} />
  }
}

export const AWSReviewTable = ({data, resourceType}) => {

    const {
      items,
      filteredItemsCount = 0,
      paginationProps,
      filterProps,
  } = useCollection( data, {
      filtering: {
          empty: <TableWithNoData message={NO_ITEMS_FOUND}/>,
          noMatch: <TableWithNoData message={NO_MATCHES_FOUND}/>
      },
      pagination:  { pageSize: 15 }
  });

    return <Table
    header={<Header variant="h2">{getResourceName(resourceType)} Resources</Header>}
    columnDefinitions={resourceColumnDefinition(resourceType)}
    items={items}
    pagination={
      <Pagination
          {...paginationProps}
          ariaLabels={{
              nextPageLabel: "Next page",
              previousPageLabel: "Previous page",
              pageLabel: pageNumber =>
                  `Page ${pageNumber} of all pages`
          }}
      />
  }
    empty={
      <Box textAlign="center" color="inherit">
        <Box
          padding={{ bottom: "s" }}
          variant="p"
          color="inherit"
        >
          No {getResourceName(resourceType)} resources selected.
        </Box>
      </Box>
    }
    filter={
        <TextFilter
            {...filterProps}
            filteringAriaLabel={"Filter exception occurrences"}
            filteringPlaceholder="Find exception occurrences"
            countText={getFilterCounterText(filteredItemsCount)}
        />
    }
  /> 
}

export const DynamoReviewTable = ({data}) => {

    const {
      items,
      filteredItemsCount = 0,
      paginationProps,
      filterProps,
  } = useCollection( data, {
      filtering: {
          empty: <TableWithNoData message={NO_ITEMS_FOUND}/>,
          noMatch: <TableWithNoData message={NO_MATCHES_FOUND}/>
      },
      pagination:  { pageSize: 15 }
  });

  return <Table
  header={<Header variant="h2">DynamoDB Resources</Header>}
  columnDefinitions={resourceColumnDefinition(AWS_RESOURCE_TYPE.DYNAMO_DB.type)}
  items={items}
  loadingText="Loading resources"
  pagination={
    <Pagination
        {...paginationProps}
        ariaLabels={{
            nextPageLabel: "Next page",
            previousPageLabel: "Previous page",
            pageLabel: pageNumber =>
                `Page ${pageNumber} of all pages`
        }}
    />
  }  
  empty={
    <Box textAlign="center" color="inherit">
      <Box
        padding={{ bottom: "s" }}
        variant="p"
        color="inherit"
      >
        No DynamoDB tables selected.
      </Box>
    </Box>
  }
  filter={
      <TextFilter
          {...filterProps}
          filteringAriaLabel={"Filter exception occurrences"}
          filteringPlaceholder="Find exception occurrences"
          countText={getFilterCounterText(filteredItemsCount)}
      />
  }
/> 
}

export const KMSReviewTable = ({data}) => {

    const {
      items,
      filteredItemsCount = 0,
      paginationProps,
      filterProps,
  } = useCollection( data, {
      filtering: {
          empty: <TableWithNoData message={NO_ITEMS_FOUND}/>,
          noMatch: <TableWithNoData message={NO_MATCHES_FOUND}/>
      },
      pagination:  { pageSize: 15 }
  });

  return <Table
  header={<Header variant="h2">KMS Resources</Header>}
  columnDefinitions={resourceColumnDefinition(AWS_RESOURCE_TYPE.KMS.type)}
  items={items}
  loadingText="Loading resources"
  pagination={
    <Pagination
        {...paginationProps}
        ariaLabels={{
            nextPageLabel: "Next page",
            previousPageLabel: "Previous page",
            pageLabel: pageNumber =>
                `Page ${pageNumber} of all pages`
        }}
    />
  }
  empty={
    <Box textAlign="center" color="inherit">
      <Box
        padding={{ bottom: "s" }}
        variant="p"
        color="inherit"
      >
        No DynamoDB tables selected.
      </Box>
    </Box>
  }
  filter={
      <TextFilter
          {...filterProps}
          filteringAriaLabel={"Filter exception occurrences"}
          filteringPlaceholder="Find exception occurrences"
          countText={getFilterCounterText(filteredItemsCount)}
      />
  }
/> 
}

export const S3ReviewTable = ({data}) => {

    const {
      items,
      filteredItemsCount = 0,
      paginationProps,
      filterProps,
  } = useCollection( data, {
      filtering: {
          empty: <TableWithNoData message={NO_ITEMS_FOUND}/>,
          noMatch: <TableWithNoData message={NO_MATCHES_FOUND}/>
      },
      pagination:  { pageSize: 15 }
  });

  return <Table
  header={<Header variant="h2">S3 Resources</Header>}
  columnDefinitions={resourceColumnDefinition(AWS_RESOURCE_TYPE.S3.type)}
  items={items}
  loadingText="Loading resources"
  empty={
    <Box textAlign="center" color="inherit">
      <Box
        padding={{ bottom: "s" }}
        variant="p"
        color="inherit"
      >
        No DynamoDB tables selected.
      </Box>
    </Box>
  }
  pagination={
    <Pagination
        {...paginationProps}
        ariaLabels={{
            nextPageLabel: "Next page",
            previousPageLabel: "Previous page",
            pageLabel: pageNumber =>
                `Page ${pageNumber} of all pages`
        }}
    />
  }
  filter={
      <TextFilter
          {...filterProps}
          filteringAriaLabel={"Filter exception occurrences"}
          filteringPlaceholder="Find exception occurrences"
          countText={getFilterCounterText(filteredItemsCount)}
      />
  }
/> 
  }